module.exports = __webpack_public_path__ + "img/WhatsApp Image 2019-10-17 at 6.25.33 PM (12).c9ade647.jpeg";